export enum TransferDialogState {
  INITIAL = 'Initial',
  // Request is sent and we await result
  REQUEST = 'Request',
  // when request completed, but payment is not completed (e.g. External payment)
  PROCESSING = 'Processing',
  // Pending is a status for only RTP transfers that wasn't sent immediately
  PENDING = 'Pending',
  SUCCESS = 'Success',
  FAIL = 'Fail',
  AWAITING_APPROVAL = 'AwaitingApproval',
}
